import { Text } from 'app/shared/ui';
import PropTypes from 'prop-types';

import { color } from 'app/shared/styles_js/variables';

export const MessageText = ({ children }) => (
  <Text
    as="div"
    fontSize={12}
    lineHeight={1.33}
    py={0}
    px={12}
    mt="4px"
    mb={15}
    color={color.brandDanger}
    css={{ border: '1px solid transparent', minHeight: 15 }}
  >
    {children}
  </Text>
);

MessageText.propTypes = {
  children: PropTypes.string,
};

MessageText.defaultProps = {
  children: null,
};
